module.exports = __webpack_public_path__ + "img/svg/identity-reverse.18056d2519e4cb957760760740d7aa6d.svg";